// The table inputs of an open-ended block, ported from the coffee block's calcTableProps.
//
// The rows and columns are built by the block itself, from the answer and the tag list its charts
// model assembles; what cannot be reached there is resolved here - the decimals setting, whether
// individual data is on, and whether an answer label is clickable.
//
// The combo family replaces this one; see cx/lib/props/table.

import { getModelValue, getFeature } from '@aytm/app/stats/lib/stat-page'
import { isClickable, resolvePercentDecimals } from '@aytm/app/stats/page/components/lib/utils'

export const calcTableProps = ({
  id,
  components,
  format,
  sortOrder,
  clickable,
  reportPercentDecimals,
  handlers = {}
} = {}) => ({
  id,
  components,
  percentDecimals: resolvePercentDecimals(format, reportPercentDecimals ?? getModelValue('percentDecimals')),
  sortOrder,
  commentsEnabled: 'off' !== getFeature('individual_data')?.status?.oe,
  clickable: isClickable(format, clickable),
  onSort: handlers.onSort,
  onLabelClick: handlers.onLabelClick,
  onCommentsClick: handlers.onCommentsClick,
  onSkipsToClick: handlers.onSkipsToClick
})
